import { render } from "./ChatSelectGroup.vue?vue&type=template&id=647b9e2b"
import script from "./ChatSelectGroup.vue?vue&type=script&lang=js"
export * from "./ChatSelectGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__